import React, { useState, useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import ConstantHelper from "../../../Helpers/ConstantHelper";
import EventListData from "./EventListData";
import ColorHelper from "../../../Helpers/ColorHelper";
import { Box, IconButton, InputAdornment, Typography } from "@mui/material";
import FontHelper from "../../../Helpers/FontHelper";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import "./EventSelectBox.css";
import { VisibilityOff } from "@mui/icons-material";
import { Modal } from "@mui/material";
import IconHelper from "../../../Helpers/IconHelper";

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import axios from "axios";
import { ApiManager } from "../../../ApiClient";

export default function EventSelectBox(props) {

  const { selectedEvent, setSelectedEvent, events, setEventDetails, setIsLoading } = props;
  const [inputValue, setInputValue] = useState("");
  const session_token = localStorage.getItem("session_token");

  const [style, setStyle] = useState("combo-box-demo");
  const [selectValue, setSelectValue] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleChange = (event) => {
    setSelectValue(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpenModal(false)
  };

  const handleDateFormat = (newDate) => {
    // console.log("datecheck", newDate)
  };

  useEffect(() => {
    setSelectedEvent(selectValue);
    // console.log("selectValue", selectValue)
  }, [selectValue]);

  const handleEventSelect = async (value) => {
    setIsLoading(true)
    // console.log("1223", value)
    const response = await axios.post(ApiManager.getEventDetails(), {
      eventID: value?.event_id,
      eventName: value?.event_name,
      sessionToken: session_token || ""
    })
    if (response.data.StatusCode == "200") {
      setIsLoading(false)
      setSelectedEvent(response.data.result[0]);
      localStorage.setItem("session_token", response.data.sessionDetails[0].session_token)
    }
  }

  let widthOfSelect = 350;

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    borderRadius: "10px",
    bgcolor: 'background.paper',
    p: 4,
  };

  return (
    <FormControl
      sx={{
        border: "4px",
        borderRadius: "4px",
        color: "white",
        minWidth: "100%", // Changed: consistent width instead of responsive
        marginTop: "0px", // Changed: removed negative margin
        px: "0px",
        width: "100%", // Added: ensure full width
      }}
    >
      <Autocomplete
        disablePortal
        id={style}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        onChange={(event, newValue) => {
          {
            newValue == null ? setStyle("") : setStyle("afterSubmit");
          }

          localStorage.setItem("Selected Event", newValue?.event_name);
          localStorage.setItem("Selected Event Id", newValue?.event_id);

          newValue ? handleEventSelect(newValue) : setSelectedEvent(newValue)
        }}
        size="small"
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        options={events}
        getOptionLabel={(option) =>
          option.event_name ? option.event_name : ""
        }
        renderOption={(props, option) => (
          <MenuItem {...props} style={{ fontSize: '14px' }}>
            {option.event_name}
          </MenuItem>
        )}
        freeSolo
        sx={{
          width: "100%", // Changed: consistent full width
          color: ColorHelper.WhiteColor,
          backdropFilter: "blur(8px)",
          borderRadius: "8px", // Changed: consistent border radius
          border: `1px solid ${ColorHelper.WhiteColor}`,
          background: "rgba(244, 248, 255, 0.2)",
          // Conditional styling for when event is selected
          ...(selectedEvent && {
            background: ColorHelper.WhiteColor,
            "& .MuiInputBase-input": {
              color: "#000", // Change text color to black when background is white
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#666", // Darker placeholder when background is white
            },
            "#combo-box-demo + div > button > svg > path": {
              fill: "#000", // Change dropdown arrow to black
            },
          }),
          input: {
            height: { xs: "2.2rem", md: "2.5rem", lg: "2.5rem" },
            color: ColorHelper.WhiteColor,
            outline: "none",
            "&::placeholder": {
              fontSize: 16,
              color: ColorHelper.WhiteColor,
            },
          },
          "& fieldset": { border: "none" },
          "#combo-box-demo + div > button > svg > path": {
            fill: ColorHelper.WhiteColor,
          },
          // Keep consistent border radius
          "& .MuiInputBase-root": {
            borderRadius: "8px !important",
          }
        }}
        renderInput={(params) => (
          <TextField
            sx={{ 
              fontFamily: FontHelper.fRegular,
              "& .MuiInputBase-root": {
                color: ColorHelper.WhiteColor,
                paddingRight: !selectedEvent ? "8px" : "auto", // Add padding when icon is visible
              }
            }}
            {...params}
            placeholder={ConstantHelper.SerachFieldTitle}
            InputProps={{
              ...params.InputProps,
              endAdornment: !selectedEvent ? (
                <InputAdornment 
                  position="end"
                  sx={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none", // Make it non-clickable, just visual
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path 
                      d="M7 10l5 5 5-5z" 
                      fill={ColorHelper.WhiteColor}
                    />
                  </svg>
                </InputAdornment>
              ) : params.InputProps.endAdornment,
            }}
          />
        )}
      />
    </FormControl>
  );
}